export const areaGovernVocabulary: {
  title: string;
  token: string;
}[] = [
  {
    title: 'Benestar social i ciutadania',
    token: '0',
  },
  {
    title: 'Cultura, Llengua i Mitjans de Comunicaci\u00f3',
    token: '1',
  },
  {
    title: 'Dret i Just\u00edcia',
    token: '2',
  },
  {
    title: 'Drets de les persones amb discapacitat',
    token: '3',
  },
  {
    title: 'Economia, empresa i treball',
    token: '4',
  },
  {
    title: 'Esport i activitat f\u00edsica',
    token: '5',
  },
  {
    title: 'Feminismes i igualtat',
    token: '6',
  },
  {
    title: 'Gent gran',
    token: '7',
  },
  {
    title: 'Joventut',
    token: '8',
  },
  {
    title: 'LGTBI+',
    token: '9',
  },
  {
    title: 'Migracions, Arrelament i Ciutadania',
    token: '10',
  },
  {
    title: 'Mon Rural',
    token: '11',
  },
  {
    title: 'Pallars Juss\u00e0',
    token: '12',
  },
  {
    title: 'Pol\u00edtica Internacional',
    token: '13',
  },
  {
    title: 'Primer Sector',
    token: '14',
  },
  {
    title: 'Protecci\u00f3 dels animals',
    token: '15',
  },
  {
    title: 'Relacions entre Institucions i Govern Obert',
    token: '16',
  },
  {
    title: 'Salut',
    token: '17',
  },
  {
    title: 'Seguretat i defensa',
    token: '18',
  },
  {
    title: 'Societat digital i Tecnologia',
    token: '19',
  },
  {
    title: 'Societat per al coneixement',
    token: '20',
  },
  {
    title: 'Territori i Medi ambient',
    token: '21',
  },
  {
    title: 'Transici\u00f3 Energ\u00e8tica',
    token: '22',
  },
];
